// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__320hR","loaderOuter":"PageOverlayLoader_loaderOuter__38aI-"};